/* ==========================================================================
   tl-combo.js — Tokyo Lifestyle · Track Pant Combo landing
   --------------------------------------------------------------------------
   Runs the four-slot combo builder, the EN/বাংলা switch, the theme switch and
   the scroll choreography on /pages/combo.

   Compatibility note: this page's traffic is overwhelmingly Android inside the
   Facebook / Instagram in-app browser, so the code deliberately stays inside
   ES2015 — no optional chaining, no nullish coalescing, no object spread, no
   Array.prototype.flat. IntersectionObserver and fetch are feature-detected.

   Pricing note: LADDER is not a marketing invention. Each figure was verified
   against the live cart at tokyolifestyle.online with the two automatic
   discounts in place ("Track Pant Combo — 2 Pairs ৳1800" and "Track Pant Combo
   — Buy 3 Get 1 Free"). Shopify applies whichever automatic discount is best
   for the customer, which produces exactly this ladder. If either discount is
   ever edited or paused, these numbers must be re-verified — the page must
   never quote a total the checkout will not honour.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('tlc-root');
  var dataEl = document.getElementById('tlc-data');
  if (!root || !dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var SLOTS = DATA.slots || 4;
  var UNIT = DATA.unit || 950;
  var LADDER = DATA.ladder || { 1: 950, 2: 1800, 3: 2750, 4: 2850 };
  /* Two pricing engines, chosen per page:
       'ladder'        — every item is the same price, so the total for N pairs is
                         a fixed figure (the track pant combo).
       'cheapest-free' — items have different prices, so the total is the real
                         subtotal minus the cheapest item at 4+, or minus a flat
                         two-pair saving at 2–3 (the jogger combo).
     Both were verified against live carts; see the section file's header. */
  var PRICING = DATA.pricing === 'cheapest-free' ? 'cheapest-free' : 'ladder';
  var TWO_OFF = DATA.twoPairOff || 0;
  var DELIVERY = DATA.delivery || { inside: 70, outside: 130 };
  var STYLES = DATA.styles || [];
  var SIZE_CHART = DATA.sizeChart || [];
  var AUTOPLAY = DATA.autoplay !== false;
  var AUTOPLAY_MS = (DATA.autoplaySec || 4) * 1000;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Copy ───────────────────────────────────────────────────────────────
     Every visible string lives here so the two languages can never drift.
     Keys are referenced from the markup via data-i18n / data-i18n-html.     */
  var BN = {
    'nav.offer': 'অফার',
    'nav.styles': 'স্টাইল',
    'nav.sizing': 'সাইজ',
    'nav.faq': 'প্রশ্ন',
    'nav.order': 'অর্ডার করুন',
    'nav.themeLabel': 'থিম বদলান',

    'tape.cod': 'সারা বাংলাদেশে ক্যাশ অন ডেলিভারি',
    'tape.product': 'প্রিমিয়াম সাইড-স্ট্রাইপ ট্র্যাক প্যান্ট',
    'tape.colours': 'অলিভ · নেভি · অ্যাশ · ব্ল্যাক',
    'tape.offer': '৩টি কিনুন ১টি ফ্রি — ৳২৮৫০',
    'tape.flat': '৯টি স্টাইল · সবগুলোই ৳৯৫০',
    'tape.stock': 'এস থেকে ডাবল-এক্সএল স্টকে আছে',

    'hero.badge': 'সীমিত কম্বো · স্টক থাকা পর্যন্ত',
    'hero.title1': 'চারটি বেছে নিন।',
    'hero.title2': 'তিনটির দাম দিন।',
    'hero.tape': '<b>৳২৮৫০</b>-এ চারটি — সেভ ৳৯৫০',
    'hero.lead':
      'প্রিমিয়াম পারফরম্যান্স ট্র্যাক প্যান্ট — ভেতরে ডবি লাইনিং সহ মাইক্রো ফ্যাব্রিক, ইলাস্টিক ড্রস্ট্রিং কমর, জিপ পকেট আর পরিষ্কার কনট্রাস্ট সাইড স্ট্রাইপ। ৯টি স্টাইল, সবগুলোরই দাম ৳৯৫০। যেকোনো চারটি মিলিয়ে নিন।',
    'hero.cta1': 'কম্বো সাজান',
    'hero.cta2': '৯টি স্টাইল দেখুন',
    'hero.stat1k': 'প্রতি পিস',
    'hero.stat2v': '৪টি',
    'hero.stat2k': '৩টির দামে',
    'hero.stat3k': 'সাইজ স্টকে',
    'hero.railk': 'যেকোনো ৪টি মিলিয়ে নিন',
    'hero.floatOffer': '৩টি কিনুন → <em>১টি ফ্রি</em>',
    'hero.floatK': '৪ পিস কম্বো',

    'ladder.eyebrow': 'অফার',
    'ladder.h2': 'একটাই দাম। যত বেশি নেবেন, তত সস্তা।',
    'ladder.lead':
      'ডিসকাউন্ট চেকআউটে নিজে থেকেই বসে যায় — কোনো কুপন কোড লাগে না।',
    'ladder.t1q': '১ পিস',
    'ladder.t2q': '২ পিস',
    'ladder.t3q': '৩ পিস',
    'ladder.t4q': '৪ পিস',
    'ladder.perPair': 'প্রতি পিস',
    'ladder.save': 'সেভ',
    'ladder.best': 'সেরা ডিল',
    'ladder.pick': 'এটাই নিন',
    'build.ready': '{n} পিস · {p} — চেকআউট করতে পারেন',
    'build.mix0': 'যেকোনো ৪টি বেছে নিন — সবচেয়ে কম দামের পিসটি ফ্রি',
    'build.mixMore': 'আরও {n}টি বাছুন — তারপর সবচেয়ে কম দামের পিসটি ফ্রি',
    'build.mixLast': 'শেষ পিসটি যোগ করুন মাত্র {p} বেশি দিয়ে — সবচেয়ে কম দামেরটি ফ্রি হয়ে যাবে',
    'build.mixDone': 'সবচেয়ে কম দামের পিসটি ফ্রি — আপনি সেভ করছেন {p}',
    'ladder.kicker':
      'আপনার ৪র্থ পিসটির জন্য ৩য়টির চেয়ে মাত্র <b>৳১০০</b> বেশি লাগছে।',

    'build.eyebrow': 'কম্বো সাজান',
    'build.h2': 'আপনার চারটি বেছে নিন',
    'build.note':
      'একটি স্লটে ট্যাপ করুন, স্টাইল বাছুন, সাইজ বাছুন। যেভাবে খুশি মেলাতে পারেন — চারটি একই স্টাইল, বা চারটি আলাদা। ডিসকাউন্ট চেকআউটে নিজে থেকেই বসে যাবে।',
    'build.slotEmpty': 'স্টাইল বাছুন',
    'build.slotFree': 'এই পিসটি ফ্রি',
    'build.free': 'ফ্রি',
    'build.remove': 'সরিয়ে দিন',
    'build.nudge0': 'প্রথম পিসটি বেছে নিন — ৳৯৫০',
    'build.nudge1': 'আরও ১টি নিলে ২ পিস ৳১৮০০ — সেভ ৳১০০',
    'build.nudge2': 'আরও ১টি নিলে ৩ পিস ৳২৭৫০',
    'build.nudge3':
      '৪র্থ পিসটি যোগ করুন মাত্র <b>৳১০০</b>-এ — মোট সেভ <b>৳৯৫০</b>',
    'build.nudge4': '৩টি কিনে ১টি ফ্রি চালু হয়েছে — আপনি সেভ করছেন ৳৯৫০',

    'sum.h': 'আপনার কম্বো',
    'sum.count': 'পিস',
    'sum.empty': 'এখনো কোনো পিস বাছা হয়নি।',
    'sum.areaK': 'ডেলিভারি এলাকা',
    'sum.inside': 'ঢাকার ভেতরে',
    'sum.outside': 'ঢাকার বাইরে',
    'sum.subtotal': 'পিসের দাম',
    'sum.saving': 'কম্বো সেভিং',
    'sum.delivery': 'ডেলিভারি',
    'sum.total': 'সর্বমোট',
    'sum.cta': 'কার্টে দিয়ে চেকআউট করুন',
    'sum.ctaWait': 'আরও পিস বাছুন',
    'sum.adding': 'যোগ করা হচ্ছে…',
    'sum.trust1': 'সারা বাংলাদেশে ক্যাশ অন ডেলিভারি',
    'sum.trust2': '৭ দিনের মধ্যে সাইজ বদলানো যাবে',
    'sum.trust3': 'ঢাকার ভেতরে ১–৩ দিনে ডেলিভারি',
    'sum.err': 'কিছু একটা ভুল হয়েছে। আরেকবার চেষ্টা করুন।',
    'sum.errStock': 'দুঃখিত, এই সাইজে আর স্টক নেই। অন্য একটি বেছে নিন।',
    'sum.cartHas': 'আপনার কার্টে আগেই {n}টি অন্য পণ্য আছে — চেকআউটে সেগুলোও যোগ হবে।',

    'pick.h1': 'স্টাইল বাছুন',
    'pick.h2': 'সাইজ বাছুন',
    'pick.step1': 'ধাপ ১ / ২',
    'pick.step2': 'ধাপ ২ / ২',
    'pick.close': 'বন্ধ করুন',
    'pick.back': 'স্টাইলে ফিরে যান',
    'pick.left': 'পিস বাকি',
    'pick.out': 'স্টক শেষ',
    'pick.low': 'শেষ {n}টি',
    'pick.slot': 'স্লট {n}',
    'pick.chart': 'সাইজ চার্ট (ইঞ্চি)',
    'pick.chartHint': 'কমরের মাপ দেখে সাইজ বাছুন',

    'styles.eyebrow': 'কালারওয়ে',
    'styles.h2': '৯টি স্টাইল, সবগুলোরই দাম ৳৯৫০',
    'styles.lead':
      'প্রতিটি স্টাইল এস থেকে ডাবল-এক্সএল পর্যন্ত। যেকোনো চারটি মিলিয়ে কম্বো বানান।',
    'styles.view': 'পণ্যটি দেখুন',
    'styles.add': 'কম্বোতে যোগ করুন +',
    'styles.soldout': 'স্টক শেষ',
    'toast.soldout': 'এই স্টাইলটির স্টক শেষ',
    'toast.full': 'চারটি স্লটই ভরা — বদলাতে একটি স্লটে ট্যাপ করুন',

    'spec.eyebrow': 'যেভাবে বানানো',
    'spec.h2': 'চলার জন্য তৈরি, টেকার জন্য তৈরি',
    'spec.t1': 'ডবি লাইনিং মাইক্রো ফ্যাব্রিক',
    'spec.d1': 'ভেতরে ডবি লাইনিং সহ হালকা মাইক্রো ফ্যাব্রিক — নিঃশ্বাস নেয়, গায়ে লেগে থাকে না।',
    'spec.t2': 'ইলাস্টিক ড্রস্ট্রিং কমর',
    'spec.d2': 'ইলাস্টিক কমরের সাথে ড্রকর্ড — নিজের মাপে টেনে নিন, সারাদিন ঠিক থাকে।',
    'spec.t3': 'জিপ পকেট',
    'spec.d3': 'সামনে ও পেছনে জিপ দেওয়া পকেট — ফোন আর মানিব্যাগ নিরাপদ।',
    'spec.t4': 'কনট্রাস্ট সাইড স্ট্রাইপ',
    'spec.d4': 'পাশে পরিষ্কার কনট্রাস্ট স্ট্রাইপ — জিমে, রাস্তায়, সব জায়গায় মানায়।',
    'spec.t5': 'কাফড অ্যাঙ্কেল',
    'spec.d5': 'পায়ের গোড়ালিতে কাফ দেওয়া — টেপারড ফিট, জুতোর ওপরে সুন্দর বসে।',
    'spec.t6': 'মেশিনে ধোয়া যায়',
    'spec.d6': 'একই রঙের কাপড়ের সাথে মাইল্ড ডিটারজেন্টে ধুয়ে নিন। ব্লিচ দেবেন না।',

    'how.eyebrow': 'কীভাবে কাজ করে',
    'how.h2': '৳২৮৫০-এ পৌঁছানোর তিন ধাপ',
    'how.t1': 'চারটি স্লট ভরুন',
    'how.d1': 'যেকোনো চারটি স্টাইল আর সাইজ বাছুন। চারটি একই হলেও চলবে।',
    'how.t2': 'চেকআউট করুন',
    'how.d2': 'ডিসকাউন্ট নিজে থেকেই বসে যাবে। নাম, ঠিকানা আর ফোন নম্বর দিন।',
    'how.t3': 'হাতে পেয়ে টাকা দিন',
    'how.d3': 'ক্যাশ অন ডেলিভারি সারা বাংলাদেশে। কুরিয়ারের হাতে টাকা দিন।',

    'size.eyebrow': 'সাইজ',
    'size.h2': 'আপনার সাইজ বের করুন',
    'size.thSize': 'সাইজ',
    'size.thUk': 'ইউকে',
    'size.thWaist': 'কমর (ইঞ্চি)',
    'size.thLength': 'লম্বা (ইঞ্চি)',
    'size.thThigh': 'থাই (ইঞ্চি)',
    'size.thOpening': 'পায়ের মুখ (ইঞ্চি)',
    'size.note':
      'কমরের মাপ দুটি সিরিজ (সাইড-স্ট্রাইপ ও থ্রি-স্ট্রাইপ) দুটোই কভার করে। লম্বা, থাই আর পায়ের মুখের মাপ সাইড-স্ট্রাইপ সিরিজের। প্রতিটি স্টাইলের নিজের পুরো চার্ট সেই পণ্যের পেজে আছে। মাপ সমান করে বিছিয়ে নেওয়া, ±০.৫ ইঞ্চি এদিক-ওদিক হতে পারে।',

    'faq.eyebrow': 'প্রশ্ন-উত্তর',
    'faq.h2': 'যা জিজ্ঞেস করা হয়',
    'faq.q1': 'চারটি কি আলাদা আলাদা স্টাইল আর সাইজ নিতে পারি?',
    'faq.a1':
      'পারবেন। চারটি স্লটের প্রতিটিতে আলাদা স্টাইল আর আলাদা সাইজ নিতে পারেন — অথবা চারটি একই। দাম একই থাকবে, ৳২৮৫০।',
    'faq.q2': 'ডিসকাউন্ট পেতে কোনো কুপন কোড লাগবে?',
    'faq.a2':
      'না। ডিসকাউন্টটি অটোমেটিক — কার্টে চারটি ট্র্যাক প্যান্ট থাকলেই চেকআউটে ৳৯৫০ কমে যাবে।',
    'faq.q3': 'ডেলিভারি চার্জ কত?',
    'faq.a3': 'ঢাকার ভেতরে ৳৭০, ঢাকার বাইরে ৳১৩০। ক্যাশ অন ডেলিভারি সারা বাংলাদেশে।',
    'faq.q4': 'সাইজ না মিললে কী হবে?',
    'faq.a4':
      'পণ্য হাতে পাওয়ার ৭ দিনের মধ্যে সাইজ বদলে নিতে পারবেন, যদি ট্যাগ লাগানো থাকে আর পণ্যটি না-পরা অবস্থায় থাকে।',
    'faq.q5': 'কতদিনে পৌঁছাবে?',
    'faq.a5': 'ঢাকার ভেতরে সাধারণত ১–৩ দিন, ঢাকার বাইরে ২–৫ দিন।',
    'faq.q6': 'অফারটি কতদিন থাকবে?',
    'faq.a6':
      'স্টক থাকা পর্যন্ত। এটি একটি সীমিত কম্বো — সাইজ শেষ হয়ে গেলে সেটি আর বাছা যাবে না।',

    'close.t1': 'চারটি নিন।',
    'close.t2': 'তিনটির দাম দিন।',
    'close.d':
      '৳২৮৫০-এ চার পিস প্রিমিয়াম ট্র্যাক প্যান্ট। সারা বাংলাদেশে ক্যাশ অন ডেলিভারি।',
    'close.cta': 'কম্বো সাজান',

    'foot.shopH': 'শপ',
    'foot.helpH': 'সহায়তা',
    'foot.aboutH': 'টোকিও লাইফস্টাইল',
    'foot.combo': 'কম্বো অফার',
    'foot.allTrack': 'সব ট্র্যাক প্যান্ট',
    'foot.allProducts': 'সব পণ্য',
    'foot.sizeGuide': 'সাইজ গাইড',
    'foot.contact': 'যোগাযোগ',
    'foot.track': 'অর্ডার ট্র্যাক করুন',
    'foot.rights': 'সর্বস্বত্ব সংরক্ষিত।',
    'foot.tagline': 'বাংলাদেশে প্রিমিয়াম ফ্যাশন ও স্পোর্টসওয়্যার।',

    'dock.k': 'সর্বমোট',
    'fcart.empty': 'কম্বো সাজান',
    'fcart.of': '{n}টির মধ্যে {t}টি বাছা হয়েছে',
    'fcart.ready': 'চেকআউট করতে পারেন',
    'fcart.save': 'সেভ {p}',
    'det.h': 'আপনার তথ্য',
    'det.step': 'ধাপ ২ / ২',
    'det.name': 'পুরো নাম',
    'det.phone': 'মোবাইল নম্বর',
    'det.address': 'পুরো ঠিকানা',
    'det.city': 'শহর / জেলা',
    'det.email': 'ইমেইল <em>(না দিলেও চলবে)</em>',
    'det.note': 'পরের ধাপে শপিফাইয়ের নিরাপদ চেকআউট — আপনার তথ্য আগেই বসানো থাকবে। ক্যাশ অন ডেলিভারি, SSLCommerz বা বিকাশ বেছে নিয়ে অর্ডার নিশ্চিত করুন।',
    'det.errName': 'নাম লিখুন',
    'det.errPhone': 'সঠিক মোবাইল নম্বর দিন (যেমন ০১৭XXXXXXXX)',
    'det.errAddress': 'ঠিকানা লিখুন',
    'det.errCity': 'শহর বা জেলার নাম লিখুন',
    'sum.ctaDetails': 'তথ্য দিয়ে অর্ডার করুন',
    'dock.cta': 'চেকআউট',
    'dock.pick': 'কম্বো সাজান',
    'toast.added': 'কার্টে যোগ হয়েছে — চেকআউটে যাচ্ছি…',
    'toast.removed': 'সরিয়ে দেওয়া হয়েছে'
  };

  /* English copy for the strings the JS builds itself (slots, picker, summary,
     toasts). Everything that exists in the server-rendered markup is read out
     of the DOM instead — see readEnglish() — so page copy has exactly one
     home and the two halves cannot drift. */
  var EN_JS = {
    'build.slotEmpty': 'Choose a style',
    'build.slotFree': 'This pair is free',
    'build.free': 'Free',
    'build.remove': 'Remove this pair',
    'build.nudge0': 'Pick your first pair — ৳950',
    'build.nudge1': 'Add 1 more → 2 pairs ৳1800, save ৳100',
    'build.nudge2': 'Add 1 more → 3 pairs ৳2750',
    'build.nudge3':
      'Add your 4th pair for just <b>৳100</b> more — total saving <b>৳950</b>',
    'build.nudge4': 'Buy 3 Get 1 Free unlocked — you save ৳950',
    'sum.count': 'pairs',
    'sum.empty': 'No pairs chosen yet.',
    'sum.adding': 'Adding…',
    'sum.cta': 'Add to cart & checkout',
    'sum.ctaWait': 'Choose your pairs',
    'sum.err': 'Something went wrong. Please try again.',
    'sum.errStock': 'Sorry, that size just sold out. Please pick another.',
    'sum.cartHas':
      'Your cart already has {n} other item(s) — those are added at checkout too.',
    'pick.h1': 'Choose a style',
    'pick.h2': 'Choose a size',
    'pick.step1': 'Step 1 / 2',
    'pick.step2': 'Step 2 / 2',
    'pick.back': 'Back to styles',
    'pick.left': 'left',
    'pick.out': 'Sold out',
    'pick.low': 'Only {n} left',
    'pick.slot': 'Slot {n}',
    'ladder.pick': 'Choose this',
    'build.ready': '{n} pairs · {p} — ready to checkout',
    'build.mix0': 'Pick any four — the cheapest pair comes free',
    'build.mixMore': 'Choose {n} more — then your cheapest pair is free',
    'build.mixLast': 'Add your last pair from {p} more — it makes the cheapest one free',
    'build.mixDone': 'Cheapest pair free — you save {p}',
    'pick.chart': 'Size chart (inches)',
    'pick.chartHint': 'Match your waist to pick the size',
    'dock.cta': 'Checkout',
    'fcart.empty': 'Build your combo',
    'fcart.of': '{n} of {t} pairs chosen',
    'fcart.ready': 'Ready to checkout',
    'fcart.save': 'save {p}',
    'det.h': 'Your details',
    'det.step': 'Step 2 of 2',
    'det.name': 'Full name',
    'det.phone': 'Mobile number',
    'det.address': 'Full address',
    'det.city': 'City / District',
    'det.email': 'Email <em>(optional)</em>',
    'det.note': "Next step is Shopify's secure checkout with your details already filled in — choose Cash on Delivery, SSLCommerz or bKash and confirm.",
    'det.errName': 'Please enter your name',
    'det.errPhone': 'Enter a valid mobile number (e.g. 01712345678)',
    'det.errAddress': 'Please enter your address',
    'det.errCity': 'Please enter your city or district',
    'sum.ctaDetails': 'Continue to payment',
    'dock.pick': 'Build combo',
    'toast.added': 'Added to cart — taking you to checkout…',
    'toast.removed': 'Pair removed',
    'styles.add': 'Add to combo +',
    'styles.soldout': 'Sold out',
    'toast.soldout': 'That style is sold out',
    'toast.full': 'All 4 slots are full — tap a slot to change it'
  };

  var EN = {};

  var lang = 'en';
  var dict = EN;

  function T(key) {
    if (lang === 'bn' && BN[key] != null) return BN[key];
    return EN[key] != null ? EN[key] : '';
  }

  /* Capture the English copy straight out of the server-rendered markup so the
     page works with JS disabled and the dictionary has only one hand-written
     half to maintain. */
  function readEnglish() {
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var key = n.getAttribute('data-i18n') || n.getAttribute('data-i18n-html');
      if (key && EN[key] == null) {
        EN[key] = n.getAttribute('data-i18n-html') ? n.innerHTML : n.textContent;
      }
    }
  }

  function applyLang() {
    var html = document.documentElement;
    html.setAttribute('data-lang', lang);
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var htmlKey = n.getAttribute('data-i18n-html');
      var key = htmlKey || n.getAttribute('data-i18n');
      if (!key) continue;
      var val = T(key);
      if (!val) continue;
      if (htmlKey) n.innerHTML = val;
      else n.textContent = val;
    }
    var segs = root.querySelectorAll('[data-lang-btn]');
    for (var j = 0; j < segs.length; j++) {
      segs[j].setAttribute(
        'aria-pressed',
        segs[j].getAttribute('data-lang-btn') === lang ? 'true' : 'false'
      );
    }
    render();
  }

  function setLang(next) {
    lang = next === 'bn' ? 'bn' : 'en';
    try {
      localStorage.setItem('tlc-lang', lang);
    } catch (e) {}
    applyLang();
  }

  /* ── Money ─────────────────────────────────────────────────────────────── */
  var BN_DIGITS = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

  function digits(str) {
    if (lang !== 'bn') return str;
    return String(str).replace(/[0-9]/g, function (d) {
      return BN_DIGITS[+d];
    });
  }

  function money(n) {
    var s = Math.round(n)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '৳' + digits(s);
  }

  /* ── Pricing ───────────────────────────────────────────────────────────── */
  function comboTotal(count) {
    if (count <= 0) return 0;
    if (LADDER[count] != null) return LADDER[count];
    return count * UNIT; /* defensive — the builder never exceeds SLOTS */
  }

  /* Index of the slot that the discount actually makes free — the CHEAPEST
     filled slot, not simply the last one. Shopify discounts the cheapest
     eligible line, so labelling any other slot "free" would misreport it. */
  function freeSlotIndex() {
    var count = 0;
    for (var i = 0; i < slots.length; i++) if (slots[i]) count++;
    if (count < SLOTS) return -1;
    var best = -1;
    var low = Infinity;
    for (var j = 0; j < slots.length; j++) {
      if (!slots[j]) continue;
      var pr = slots[j].price != null ? slots[j].price : UNIT;
      if (pr < low) {
        low = pr;
        best = j;
      }
    }
    return best;
  }

  function priceState() {
    var count = 0;
    var subtotal = 0;
    var cheapest = Infinity;
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i]) continue;
      count++;
      var pr = slots[i].price != null ? slots[i].price : UNIT;
      subtotal += pr;
      if (pr < cheapest) cheapest = pr;
    }

    var total;
    if (!count) {
      total = 0;
    } else if (PRICING === 'cheapest-free') {
      if (count >= SLOTS) total = subtotal - cheapest;
      else if (count >= 2) total = subtotal - TWO_OFF;
      else total = subtotal;
    } else {
      total = comboTotal(count);
    }

    var saving = Math.max(0, subtotal - total);
    var ship = count ? DELIVERY[area] : 0;
    return {
      count: count,
      subtotal: subtotal,
      combo: total,
      saving: saving,
      cheapest: count ? cheapest : 0,
      ship: ship,
      payable: total + ship
    };
  }

  /* ── State ─────────────────────────────────────────────────────────────── */
  var slots = [];
  for (var s0 = 0; s0 < SLOTS; s0++) slots.push(null);
  var area = 'inside';
  /* How many pairs the visitor said they want, set from the price-ladder cards.
     It only governs whether the picker keeps chaining to the next slot — every
     slot stays fillable, so nobody is ever blocked from taking more. */
  var target = SLOTS;
  var otherCartItems = 0;

  /* ── Element refs ──────────────────────────────────────────────────────── */
  var el = {
    slots: root.querySelector('[data-slots]'),
    prog: root.querySelector('[data-prog]'),
    nudge: root.querySelector('[data-nudge]'),
    nudgeText: root.querySelector('[data-nudge-text]'),
    sumLines: root.querySelector('[data-sum-lines]'),
    sumCount: root.querySelector('[data-sum-count]'),
    rowSub: root.querySelector('[data-row-sub]'),
    rowSave: root.querySelector('[data-row-save]'),
    rowSaveWrap: root.querySelector('[data-row-save-wrap]'),
    rowShip: root.querySelector('[data-row-ship]'),
    total: root.querySelector('[data-total]'),
    cta: root.querySelector('[data-cta]'),
    ctaLabel: root.querySelector('[data-cta-label]'),
    msg: root.querySelector('[data-msg]'),
    dock: root.querySelector('[data-dock]'),
    dockV: root.querySelector('[data-dock-v]'),
    dockWas: root.querySelector('[data-dock-was]'),
    dockCta: root.querySelector('[data-dock-cta]'),
    dockCtaLabel: root.querySelector('[data-dock-cta-label]'),
    pick: root.querySelector('[data-pick]'),
    pickBody: root.querySelector('[data-pick-body]'),
    pickTitle: root.querySelector('[data-pick-title]'),
    pickStep: root.querySelector('[data-pick-step]'),
    toast: root.querySelector('[data-toast]'),
    fcart: root.querySelector('[data-fcart]'),
    fcartDots: root.querySelector('[data-fcart-dots]'),
    fcartK: root.querySelector('[data-fcart-k]'),
    fcartV: root.querySelector('[data-fcart-v]'),
    fcartSave: root.querySelector('[data-fcart-save]'),
    details: root.querySelector('[data-details]')
  };

  /* ── Slots ─────────────────────────────────────────────────────────────── */
  function styleAt(i) {
    return STYLES[i];
  }

  function slotIsFree(index) {
    return freeSlotIndex() === index;
  }

  function renderSlots() {
    if (!el.slots) return;
    var out = '';
    for (var i = 0; i < SLOTS; i++) {
      var pick = slots[i];
      var n = i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
      var isLast = i === SLOTS - 1;

      if (!pick) {
        out +=
          '<button type="button" class="tlc-slot' +
          (isLast ? ' tlc-slot--free' : '') +
          '" data-slot="' +
          i +
          '">' +
          '<span class="tlc-slot__n">' +
          digits(n) +
          '</span>' +
          '<span class="tlc-slot__body">' +
          '<span class="tlc-slot__plus" aria-hidden="true">+</span>' +
          '<span class="tlc-slot__hint">' +
          (isLast ? T('build.slotFree') : T('build.slotEmpty')) +
          '</span>' +
          '</span>' +
          '</button>';
        continue;
      }

      var st = styleAt(pick.styleIdx);
      var freeTag = slotIsFree(i)
        ? '<span class="tlc-slot__tag tlc-slot__tag--free">' + T('build.free') + '</span>'
        : '<span class="tlc-slot__tag">' + digits(n) + '</span>';

      out +=
        '<div class="tlc-slot" data-filled="true" data-slot="' +
        i +
        '" role="button" tabindex="0">' +
        '<div class="tlc-slot__pic">' +
        '<img src="' +
        st.img +
        '" alt="' +
        esc(st.title) +
        '" loading="lazy" width="300" height="300">' +
        freeTag +
        '<button type="button" class="tlc-slot__x" data-clear="' +
        i +
        '" aria-label="' +
        esc(T('build.remove')) +
        '">&times;</button>' +
        '</div>' +
        '<div class="tlc-slot__meta">' +
        '<span class="tlc-slot__name">' +
        esc(st.colour) +
        '</span>' +
        '<span class="tlc-slot__size">' +
        esc(st.series) +
        ' · ' +
        esc(pick.size) +
        '</span>' +
        '</div>' +
        '</div>';
    }
    el.slots.innerHTML = out;
  }

  function renderProg() {
    if (!el.prog) return;
    var segs = el.prog.querySelectorAll('.tlc-prog__seg');
    for (var i = 0; i < segs.length; i++) {
      segs[i].setAttribute('data-on', slots[i] ? 'true' : 'false');
    }
  }

  function renderTiers() {
    var tiers = root.querySelectorAll('[data-tier]');
    for (var i = 0; i < tiers.length; i++) {
      tiers[i].setAttribute(
        'aria-pressed',
        Number(tiers[i].getAttribute('data-tier')) === target ? 'true' : 'false'
      );
    }
  }

  function renderNudge() {
    if (!el.nudge || !el.nudgeText) return;
    var p = priceState();
    /* Hit the goal below four pairs? Say so, rather than nagging toward four. */
    if (p.count > 0 && p.count === target && target < SLOTS) {
      el.nudgeText.innerHTML =
        T('build.ready').replace('{n}', digits(p.count)).replace('{p}', money(p.combo));
      el.nudge.setAttribute('data-hot', 'done');
      return;
    }
    if (PRICING === 'cheapest-free') {
      if (!p.count) {
        el.nudgeText.innerHTML = T('build.mix0');
      } else if (p.count < SLOTS - 1) {
        el.nudgeText.innerHTML = T('build.mixMore')
          .replace('{n}', digits(SLOTS - p.count));
      } else if (p.count === SLOTS - 1) {
        /* The strongest true line on the page: what the last pair actually adds. */
        var stepPrices = [];
        for (var q = 0; q < STYLES.length; q++) {
          for (var w = 0; w < STYLES[q].variants.length; w++) {
            var vv = STYLES[q].variants[w];
            if (vv.ok && vv.price != null) stepPrices.push(vv.price);
          }
        }
        var lowest = stepPrices.length ? Math.min.apply(null, stepPrices) : UNIT;
        /* What the final pair genuinely adds to the bill.
             now   = subtotal − TWO_OFF
             after = (subtotal + q) − min(cheapest, q)
           so the delta is  q − min(cheapest, q) + TWO_OFF.
           Taking q as the cheapest pair still available gives the best-case
           figure, which for an all-৳890 basket is just TWO_OFF — ৳90, not the
           ৳800 an earlier version of this sum reported. */
        var q = lowest;
        var step = Math.max(0, q - Math.min(p.cheapest, q) + TWO_OFF);
        el.nudgeText.innerHTML = T('build.mixLast').replace('{p}', money(step));
      } else {
        el.nudgeText.innerHTML = T('build.mixDone').replace('{p}', money(p.saving));
      }
      el.nudge.setAttribute(
        'data-hot',
        p.count === SLOTS ? 'done' : p.count === SLOTS - 1 ? 'true' : 'false'
      );
      return;
    }

    var key = 'build.nudge' + Math.min(p.count, 4);
    el.nudgeText.innerHTML = T(key);
    el.nudge.setAttribute(
      'data-hot',
      p.count === SLOTS ? 'done' : p.count === SLOTS - 1 ? 'true' : 'false'
    );
  }

  function renderSummary() {
    var p = priceState();

    if (el.sumCount) {
      el.sumCount.textContent = digits(p.count) + ' / ' + digits(SLOTS) + ' ' + T('sum.count');
    }

    if (el.sumLines) {
      if (!p.count) {
        el.sumLines.innerHTML =
          '<p class="tlc-sum__empty">' + esc(T('sum.empty')) + '</p>';
      } else {
        var out = '';
        for (var i = 0; i < SLOTS; i++) {
          if (!slots[i]) continue;
          var st = styleAt(slots[i].styleIdx);
          var free = slotIsFree(i);
          out +=
            '<div class="tlc-sum__line' +
            (free ? ' tlc-sum__line--free' : '') +
            '">' +
            '<span class="tlc-cw tlc-cw--sm" style="' +
            cwStyle(st) +
            '"></span>' +
            '<span class="tlc-sum__line-n">' +
            esc(st.colour) +
            ' · ' +
            esc(slots[i].size) +
            '</span>' +
            '<span class="tlc-sum__line-p">' +
            (free ? T('build.free') : money(slots[i].price != null ? slots[i].price : UNIT)) +
            '</span>' +
            '</div>';
        }
        el.sumLines.innerHTML = out;
      }
    }

    if (el.rowSub) el.rowSub.textContent = money(p.subtotal);
    if (el.rowSave) el.rowSave.textContent = '− ' + money(p.saving);
    if (el.rowSaveWrap) el.rowSaveWrap.hidden = p.saving <= 0;
    if (el.rowShip) el.rowShip.textContent = p.count ? money(p.ship) : '—';
    if (el.total) el.total.textContent = money(p.payable);

    var ready = p.count === SLOTS;
    var any = p.count > 0;
    if (el.cta) el.cta.disabled = !any;
    if (el.ctaLabel) {
      el.ctaLabel.textContent = !any
        ? T('sum.ctaWait')
        : el.details && el.details.hidden
        ? T('sum.ctaDetails')
        : T('sum.cta');
    }

    if (el.dockV) el.dockV.textContent = money(p.payable);
    if (el.dockWas) {
      el.dockWas.textContent = p.saving > 0 ? money(p.subtotal + p.ship) : '';
      el.dockWas.hidden = p.saving <= 0;
    }
    if (el.dockCta) el.dockCta.disabled = false;
    if (el.dockCtaLabel) {
      el.dockCtaLabel.textContent = any ? T('dock.cta') : T('dock.pick');
    }

    if (el.msg && el.msg.getAttribute('data-kind') !== 'error') {
      el.msg.textContent =
        otherCartItems > 0
          ? T('sum.cartHas').replace('{n}', digits(otherCartItems))
          : '';
    }

    if (ready && !reduceMotion) burst();
  }

  /* Floating tracker: progress dots, running total, and the saving once one
     exists. At a full combo it turns into the checkout button rather than a
     second "go to the builder" link, since the builder's work is done. */
  function renderFloatCart() {
    if (!el.fcart) return;
    var p = priceState();

    if (el.fcartDots && el.fcartDots.children.length !== SLOTS) {
      var html = '';
      for (var i = 0; i < SLOTS; i++) html += '<span class="tlc-fcart__dot"></span>';
      el.fcartDots.innerHTML = html;
    }
    if (el.fcartDots) {
      for (var j = 0; j < el.fcartDots.children.length; j++) {
        el.fcartDots.children[j].setAttribute('data-on', slots[j] ? 'true' : 'false');
      }
    }

    var ready = p.count === SLOTS;
    el.fcart.setAttribute('data-state', ready ? 'ready' : p.count ? 'building' : 'empty');
    if (el.fcartK) {
      el.fcartK.textContent = !p.count
        ? T('fcart.empty')
        : ready
        ? T('fcart.ready')
        : T('fcart.of').replace('{n}', digits(p.count)).replace('{t}', digits(SLOTS));
    }
    if (el.fcartV) el.fcartV.textContent = money(p.payable);
    if (el.fcartSave) {
      el.fcartSave.hidden = p.saving <= 0;
      el.fcartSave.textContent = T('fcart.save').replace('{p}', money(p.saving));
    }
  }

  function render() {
    renderTiers();
    renderSlots();
    renderProg();
    renderNudge();
    renderSummary();
    renderFloatCart();
  }

  /* ── Picker ────────────────────────────────────────────────────────────── */
  var pickSlot = -1;

  function cwStyle(st) {
    var a = st.cw && st.cw[0] ? st.cw[0] : '#16171a';
    var b = st.cw && st.cw[1] ? st.cw[1] : a;
    return '--cw-a:' + a + ';--cw-b:' + b;
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function openPicker(index) {
    pickSlot = index;
    if (!el.pick) return;
    el.pick.setAttribute('data-open', 'true');
    /* iOS Safari ignores overflow:hidden on <html> alone. */
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    renderPickStyles();
  }

  function closePicker() {
    if (!el.pick) return;
    el.pick.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    pickSlot = -1;
  }

  function stockLeft(st) {
    var n = 0;
    for (var i = 0; i < st.variants.length; i++) {
      if (st.variants[i].ok) n += Math.max(0, st.variants[i].qty);
    }
    return n;
  }

  /* How many of this exact variant the builder has already claimed, so we can
     stop someone reserving 3 of a size that only has 2 in stock. */
  function claimed(variantId, ignoreSlot) {
    var n = 0;
    for (var i = 0; i < slots.length; i++) {
      if (i === ignoreSlot) continue;
      if (slots[i] && slots[i].variantId === variantId) n++;
    }
    return n;
  }

  function renderPickStyles() {
    if (!el.pickBody) return;
    el.pick.setAttribute('data-step', '1');
    if (el.pickTitle) el.pickTitle.textContent = T('pick.h1');
    if (el.pickStep) {
      el.pickStep.textContent =
        T('pick.step1') + ' · ' + T('pick.slot').replace('{n}', digits(pickSlot + 1));
    }

    var out = '<div class="tlc-pgrid">';
    for (var i = 0; i < STYLES.length; i++) {
      var st = STYLES[i];
      var left = stockLeft(st);
      var out_ = left <= 0;
      out +=
        '<button type="button" class="tlc-pcard" data-style="' +
        i +
        '"' +
        (out_ ? ' data-out="true" disabled' : '') +
        '>' +
        '<span class="tlc-pcard__pic">' +
        '<img src="' +
        st.img +
        '" alt="' +
        esc(st.title) +
        '" loading="lazy" width="360" height="450">' +
        (out_
          ? '<span class="tlc-pcard__low">' + esc(T('pick.out')) + '</span>'
          : left <= 3
          ? '<span class="tlc-pcard__low">' +
            esc(T('pick.low').replace('{n}', digits(left))) +
            '</span>'
          : '') +
        '</span>' +
        '<span class="tlc-pcard__meta">' +
        '<span class="tlc-pcard__cw">' +
        '<span class="tlc-cw" style="' +
        cwStyle(st) +
        '"></span>' +
        '<span class="tlc-pcard__name">' +
        esc(st.colour) +
        '</span>' +
        '</span>' +
        '<span class="tlc-pcard__series">' +
        esc(st.series) +
        '</span>' +
        '</span>' +
        '</button>';
    }
    out += '</div>';
    el.pickBody.innerHTML = out;
    el.pickBody.scrollTop = 0;
  }

  function renderPickSizes(styleIdx) {
    if (!el.pickBody) return;
    var st = STYLES[styleIdx];
    el.pick.setAttribute('data-step', '2');
    var backBtn = el.pick.querySelector('.tlc-pick__back');
    if (backBtn) backBtn.setAttribute('aria-label', T('pick.back'));
    if (el.pickTitle) el.pickTitle.textContent = T('pick.h2');
    if (el.pickStep) {
      el.pickStep.textContent =
        T('pick.step2') + ' · ' + T('pick.slot').replace('{n}', digits(pickSlot + 1));
    }

    var chips = '';
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      var free = Math.max(0, v.qty - claimed(v.id, pickSlot));
      var can = v.ok && free > 0;
      chips +=
        '<button type="button" class="tlc-size" data-variant="' +
        v.id +
        '" data-size="' +
        esc(v.size) +
        '" data-style="' +
        styleIdx +
        '" data-price="' +
        (v.price != null ? v.price : UNIT) +
        '"' +
        (can ? '' : ' disabled') +
        '>' +
        esc(v.size) +
        (can && free <= 3
          ? '<small>' + esc(digits(free) + ' ' + T('pick.left')) + '</small>'
          : '') +
        '</button>';
    }

    /* The chart is scoped to the sizes THIS style offers, and sold-out rows are
       struck through to match the chips above — a chart listing sizes you cannot
       pick would be worse than no chart. Open by default where there is room;
       collapsed on a phone so it never buries the size buttons. */
    var offered = {};
    for (var v = 0; v < st.variants.length; v++) {
      offered[st.variants[v].size] = st.variants[v];
    }
    var rows = '';
    for (var c = 0; c < SIZE_CHART.length; c++) {
      var row = SIZE_CHART[c];
      var variant = offered[row.size];
      if (!variant) continue;
      var out = !(variant.ok && Math.max(0, variant.qty - claimed(variant.id, pickSlot)) > 0);
      rows +=
        '<tr' + (out ? ' data-out="true"' : '') + '>' +
        '<th scope="row">' + esc(row.size) + '</th>' +
        '<td>' + esc(digits(row.uk)) + '</td>' +
        '<td>' + esc(digits(row.waist)) + '</td>' +
        '<td>' + esc(digits(row.length)) + '</td>' +
        '<td>' + esc(digits(row.thigh)) + '</td>' +
        '<td>' + esc(digits(row.opening)) + '</td>' +
        '</tr>';
    }
    var chart = !rows ? '' :
      '<details class="tlc-chart"' + (window.innerWidth >= 620 ? ' open' : '') + '>' +
      '<summary><span>' + esc(T('pick.chart')) + '</span>' +
      '<small>' + esc(T('pick.chartHint')) + '</small>' +
      '<span class="tlc-chart__pm" aria-hidden="true"></span></summary>' +
      '<div class="tlc-chart__scroll"><table class="tlc-chart__table"><thead><tr>' +
      '<th>' + esc(T('size.thSize')) + '</th>' +
      '<th>' + esc(T('size.thUk')) + '</th>' +
      '<th>' + esc(T('size.thWaist')) + '</th>' +
      '<th>' + esc(T('size.thLength')) + '</th>' +
      '<th>' + esc(T('size.thThigh')) + '</th>' +
      '<th>' + esc(T('size.thOpening')) + '</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>' +
      '<p class="tlc-chart__note">' + esc(T('size.note')) + '</p>' +
      '</details>';

    el.pickBody.innerHTML =
      '<div class="tlc-psize">' +
      '<div class="tlc-psize__pic"><img src="' +
      st.img +
      '" alt="' +
      esc(st.title) +
      '" width="420" height="525"></div>' +
      '<div>' +
      '<div class="tlc-pcard__cw" style="margin-bottom:10px">' +
      '<span class="tlc-cw tlc-cw--lg" style="' +
      cwStyle(st) +
      '"></span>' +
      '<span class="tlc-pcard__series">' +
      esc(st.series) +
      '</span>' +
      '</div>' +
      '<h4 class="tlc-head tlc-psize__name">' +
      esc(st.colour) +
      '</h4>' +
      '<p class="tlc-psize__k">' +
      esc(st.title) +
      '</p>' +
      '<div class="tlc-sizes">' +
      chips +
      '</div>' +
      chart +
      '</div>' +
      '</div>';
    el.pickBody.scrollTop = 0;
  }

  /* ── Cart ──────────────────────────────────────────────────────────────── */
  function aggregate() {
    var map = {};
    var order = [];
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i]) continue;
      var id = slots[i].variantId;
      if (map[id] == null) {
        map[id] = 0;
        order.push(id);
      }
      map[id]++;
    }
    var items = [];
    for (var j = 0; j < order.length; j++) {
      items.push({ id: Number(order[j]), quantity: map[order[j]] });
    }
    return items;
  }

  function setMsg(text, kind) {
    if (!el.msg) return;
    el.msg.textContent = text || '';
    if (kind) el.msg.setAttribute('data-kind', kind);
    else el.msg.removeAttribute('data-kind');
  }

  function toast(text) {
    if (!el.toast) return;
    el.toast.textContent = text;
    el.toast.setAttribute('data-show', 'true');
    window.setTimeout(function () {
      el.toast.setAttribute('data-show', 'false');
    }, 2400);
  }


  /* ── On-page details → pre-filled Shopify checkout ──────────────────────
     A theme cannot create an order, so the hand-off goes through a cart
     permalink: /cart/{variant}:{qty},...?checkout[...]=... . A permalink also
     REPLACES the cart rather than adding to it, which conveniently rules out a
     stale cart contaminating the combo total. Verified on this store that
     email, first/last name, address1, city, postalCode and phone all pre-fill,
     and the automatic combo discount still applies. */
  function detField(name) {
    var elx = root.querySelector('[data-det="' + name + '"]');
    return elx ? String(elx.value || '').trim() : '';
  }

  function setFieldError(name, msg) {
    var elx = root.querySelector('[data-det="' + name + '"]');
    if (!elx) return;
    elx.setAttribute('data-invalid', msg ? 'true' : 'false');
    var holder = elx.parentNode;
    var err = holder.querySelector('.tlc-field__err');
    if (msg) {
      if (!err) {
        err = document.createElement('span');
        err.className = 'tlc-field__err';
        holder.appendChild(err);
      }
      err.textContent = msg;
    } else if (err) {
      err.parentNode.removeChild(err);
    }
  }

  /* Bangladeshi mobile numbers: 11 digits starting 01, optionally +880/880. */
  function normalizeBdPhone(raw) {
    var d = String(raw || '').replace(/[^0-9]/g, '');
    if (d.indexOf('880') === 0) d = d.slice(3);
    if (d.length === 10 && d.indexOf('1') === 0) d = '0' + d;
    return /^01[3-9][0-9]{8}$/.test(d) ? d : '';
  }

  function validateDetails() {
    var ok = true;
    var name = detField('name');
    var phone = normalizeBdPhone(detField('phone'));
    var addr = detField('address');
    var city = detField('city');
    setFieldError('name', name.length >= 2 ? '' : T('det.errName'));
    if (name.length < 2) ok = false;
    setFieldError('phone', phone ? '' : T('det.errPhone'));
    if (!phone) ok = false;
    setFieldError('address', addr.length >= 6 ? '' : T('det.errAddress'));
    if (addr.length < 6) ok = false;
    setFieldError('city', city.length >= 2 ? '' : T('det.errCity'));
    if (city.length < 2) ok = false;
    if (!ok) {
      var firstBad = root.querySelector('[data-det][data-invalid="true"]');
      if (firstBad) {
        firstBad.focus();
        firstBad.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    }
    return ok ? { name: name, phone: phone, addr: addr, city: city, email: detField('email') } : null;
  }

  function checkoutPermalink(d) {
    var items = aggregate();
    if (!items.length) return '';
    var parts = [];
    for (var i = 0; i < items.length; i++) parts.push(items[i].id + ':' + items[i].quantity);
    var bits = String(d.name || '').split(' ');
    var q = [];
    var add = function (k, v) {
      if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    };
    var sp = 'checkout[shipping_address]';
    add('checkout[email]', d.email);
    add(sp + '[first_name]', bits[0] || d.name);
    add(sp + '[last_name]', bits.slice(1).join(' ') || '.');
    add(sp + '[address1]', d.addr);
    add(sp + '[city]', d.city);
    add(sp + '[country]', 'Bangladesh');
    add(sp + '[phone]', d.phone);
    /* Carried onto the order so packing slips and Pathao labels show the combo. */
    add('attributes[Combo]', digits(String(items.length)) + ' pairs');
    add('attributes[Delivery area]', area === 'outside' ? 'Outside Dhaka' : 'Inside Dhaka');
    return '/cart/' + parts.join(',') + (q.length ? '?' + q.join('&') : '');
  }

  var busy = false;

  function checkout() {
    var items = aggregate();
    if (!items.length) {
      scrollToId('offer');
      return;
    }
    if (busy) return;

    /* Details are required before the hand-off, so the buyer never lands on an
       empty checkout form having already "finished" on this page. */
    if (el.details) {
      if (el.details.hidden) {
        el.details.hidden = false;
        renderSummary();
        var firstIn = el.details.querySelector('[data-det]');
        if (firstIn) {
          el.details.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          window.setTimeout(function () { firstIn.focus(); }, reduceMotion ? 0 : 420);
        }
        return;
      }
      var d = validateDetails();
      if (!d) return;
      busy = true;
      if (el.ctaLabel) el.ctaLabel.textContent = T('sum.adding');
      setMsg('');
      window.location.href = checkoutPermalink(d);
      return;
    }
    busy = true;
    if (el.ctaLabel) el.ctaLabel.textContent = T('sum.adding');
    if (el.cta) el.cta.disabled = true;
    setMsg('');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r
          .json()
          .then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          })
          .catch(function () {
            return { ok: r.ok, status: r.status, body: null };
          });
      })
      .then(function (res) {
        if (!res.ok) {
          var desc = res.body && (res.body.description || res.body.message);
          setMsg(res.status === 422 ? T('sum.errStock') : desc || T('sum.err'), 'error');
          busy = false;
          if (el.cta) el.cta.disabled = false;
          renderSummary();
          return;
        }
        toast(T('toast.added'));
        window.location.href = '/checkout';
      })
      .catch(function () {
        setMsg(T('sum.err'), 'error');
        busy = false;
        if (el.cta) el.cta.disabled = false;
        renderSummary();
      });
  }

  function readCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        otherCartItems = c && c.item_count ? c.item_count : 0;
        renderSummary();
      })
      .catch(function () {});
  }

  /* ── Flourish: a short confetti burst the first time all four land ─────── */
  var bursted = false;

  function burst() {
    if (bursted || reduceMotion) return;
    bursted = true;
    var host = el.nudge;
    if (!host) return;
    var colours = ['#b98b33', '#d3a445', '#59663a', '#f4f2ea'];
    for (var i = 0; i < 16; i++) {
      var bit = document.createElement('span');
      var ang = (Math.PI * 2 * i) / 16;
      bit.style.cssText =
        'position:absolute;left:50%;top:50%;width:6px;height:6px;pointer-events:none;' +
        'border-radius:1px;background:' +
        colours[i % colours.length] +
        ';transform:translate(-50%,-50%);opacity:1;transition:transform .9s cubic-bezier(.2,.7,.3,1),opacity .9s ease';
      host.style.position = 'relative';
      host.appendChild(bit);
      (function (node, angle) {
        window.setTimeout(function () {
          var d = 60 + Math.random() * 70;
          node.style.transform =
            'translate(' +
            (Math.cos(angle) * d - 3) +
            'px,' +
            (Math.sin(angle) * d - 3) +
            'px) rotate(' +
            Math.random() * 320 +
            'deg)';
          node.style.opacity = '0';
        }, 20);
        window.setTimeout(function () {
          if (node.parentNode) node.parentNode.removeChild(node);
        }, 1100);
      })(bit, ang);
    }
  }

  /* ── Hero colourway swap ────────────────────────────────────────────────
     The swatch rail under the hero photo reads as a control, so it is one: tap
     a colourway and the photo becomes that style. The new source is preloaded
     before the swap so the frame never flashes empty on a slow connection. */
  function setHero(index) {
    var st = STYLES[index];
    if (!st) return;

    var img = root.querySelector('[data-hero-img]');
    var label = root.querySelector('[data-hero-label]');
    var swatches = root.querySelectorAll('[data-hero]');

    for (var i = 0; i < swatches.length; i++) {
      swatches[i].setAttribute(
        'data-active',
        Number(swatches[i].getAttribute('data-hero')) === index ? 'true' : 'false'
      );
    }

    if (label) {
      label.removeAttribute('data-i18n');
      label.textContent = (st.series + ' · ' + st.colour).toUpperCase();
    }

    if (!img) return;
    var large = st.imgLg || st.img;
    /* Preload the size this viewport will actually pick from the srcset — the
       900w file is pure waste on a phone, and this audience pays for its data. */
    var wide = window.innerWidth >= 940;
    var pre = new Image();
    pre.onload = function () {
      img.src = large;
      img.srcset = st.img + ' 520w, ' + large + ' 900w';
      img.alt = st.title;
      img.style.opacity = '';
    };
    pre.onerror = function () {
      img.style.opacity = '';
    };
    if (!reduceMotion) img.style.opacity = '0.35';
    pre.src = wide ? large : st.img;
  }

  /* ── Hero autoplay ──────────────────────────────────────────────────────
     Cycles the hero through the colourways so a visitor who never touches the
     rail still sees the range. Three stop conditions, all deliberate:
       · the visitor taps a swatch — they have taken control, so we stay out
       · the hero scrolls out of view — no point burning data or battery
       · prefers-reduced-motion, or the merchant set a fixed hero image
     Nothing is prefetched ahead of time; each step preloads only its own frame. */
  var autoTimer = null;
  var autoIndex = 0;
  var autoStopped = false;

  function autoStop() {
    autoStopped = true;
    if (autoTimer) {
      window.clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function autoStart() {
    if (autoStopped || autoTimer || STYLES.length < 2) return;
    autoTimer = window.setInterval(function () {
      autoIndex = (autoIndex + 1) % STYLES.length;
      setHero(autoIndex);
    }, AUTOPLAY_MS);
  }

  function autoPause() {
    if (autoTimer) {
      window.clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function setupAutoplay() {
    if (!AUTOPLAY || reduceMotion) return;
    var frame = root.querySelector('.tlc-hero__frame');
    /* No initially-active swatch means the merchant pinned a custom hero image;
       cycling would override their choice. */
    var active = root.querySelector('[data-hero][data-active="true"]');
    if (!frame || !active) return;
    autoIndex = Number(active.getAttribute('data-hero')) || 0;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) autoStart();
            else autoPause();
          }
        },
        { threshold: 0.25 }
      );
      io.observe(frame);
    } else {
      autoStart();
    }

    /* Hovering to read the markers should not fight the rotation. */
    frame.addEventListener('mouseenter', autoPause);
    frame.addEventListener('mouseleave', function () {
      if (!autoStopped) autoStart();
    });
  }

  /* ── Scroll choreography ───────────────────────────────────────────────── */
  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function setupReveal() {
    var items = root.querySelectorAll('.tlc-rv');
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].setAttribute('data-in', 'true');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.setAttribute('data-in', 'true');
            io.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function setupNav() {
    var nav = root.querySelector('[data-nav]');
    var spineNow = root.querySelector('[data-spine-now]');
    var sections = root.querySelectorAll('[data-sec-label]');
    var links = root.querySelectorAll('[data-nav-link]');

    /* Which section is current is tracked by IntersectionObserver, NOT by
       measuring every section on each scroll frame. The old version called
       getBoundingClientRect() on all five sections inside the rAF, forcing a
       synchronous layout on every frame of every scroll — the main reason this
       page felt like it was dragging. The scroll handler below now reads only
       pageYOffset, which costs nothing. */
    function markCurrent(id) {
      var label = '';
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].id === id) label = sections[i].getAttribute('data-sec-label');
      }
      if (spineNow && label) spineNow.textContent = label;
      for (var j = 0; j < links.length; j++) {
        links[j].setAttribute(
          'aria-current',
          links[j].getAttribute('data-nav-link') === id ? 'true' : 'false'
        );
      }
    }

    if ('IntersectionObserver' in window && sections.length) {
      var seen = {};
      var secObs = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            seen[entries[i].target.id] = entries[i].isIntersecting;
          }
          /* Topmost section still in the upper band wins. */
          for (var k = sections.length - 1; k >= 0; k--) {
            if (seen[sections[k].id]) {
              markCurrent(sections[k].id);
              return;
            }
          }
        },
        { rootMargin: '-14% 0px -70% 0px' }
      );
      for (var s2 = 0; s2 < sections.length; s2++) secObs.observe(sections[s2]);
    }

    /* Pause the always-on animations while the hero is off screen. */
    var hero = document.getElementById('top');
    if ('IntersectionObserver' in window && hero) {
      var animObs = new IntersectionObserver(
        function (entries) {
          root.setAttribute('data-anim-paused', entries[0].isIntersecting ? 'false' : 'true');
        },
        { threshold: 0 }
      );
      animObs.observe(hero);
    }

    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (nav) nav.setAttribute('data-stuck', y > 12 ? 'true' : 'false');
      if (el.dock) el.dock.setAttribute('data-show', y > 420 ? 'true' : 'false');
      if (el.fcart) el.fcart.setAttribute('data-show', y > 420 ? 'true' : 'false');
    };

    var raf = false;
    window.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = true;
        window.requestAnimationFrame(function () {
          raf = false;
          onScroll();
        });
      },
      { passive: true }
    );
    onScroll();
  }

  /* ── Theme ─────────────────────────────────────────────────────────────── */
  function setTheme(next) {
    document.documentElement.setAttribute('data-theme', next);
    try {
      localStorage.setItem('tlc-theme', next);
    } catch (e) {}
  }

  function currentTheme() {
    var attr = document.documentElement.getAttribute('data-theme');
    if (attr === 'dark' || attr === 'light') return attr;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  }

  /* ── Events ────────────────────────────────────────────────────────────── */
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    /* × is nested inside the slot card, so it must be tested first. */
    var clearBtn = t.closest('[data-clear]');
    if (clearBtn) {
      slots[Number(clearBtn.getAttribute('data-clear'))] = null;
      bursted = false;
      render();
      toast(T('toast.removed'));
      return;
    }

    var slotBtn = t.closest('[data-slot]');
    if (slotBtn) {
      openPicker(Number(slotBtn.getAttribute('data-slot')));
      return;
    }

    var styleBtn = t.closest('[data-style]:not([data-variant])');
    if (styleBtn && el.pick && el.pick.getAttribute('data-open') === 'true') {
      renderPickSizes(Number(styleBtn.getAttribute('data-style')));
      return;
    }

    var sizeBtn = t.closest('[data-variant]');
    if (sizeBtn && !sizeBtn.disabled) {
      var idx = pickSlot;
      if (idx < 0) return;
      slots[idx] = {
        styleIdx: Number(sizeBtn.getAttribute('data-style')),
        variantId: Number(sizeBtn.getAttribute('data-variant')),
        size: sizeBtn.getAttribute('data-size'),
        price: Number(sizeBtn.getAttribute('data-price')) || UNIT
      };
      closePicker();
      render();
      /* Chain into the next empty slot so filling the goal is one flow — but
         stop once the visitor's chosen tier is reached. */
      var filled = 0;
      for (var f = 0; f < slots.length; f++) if (slots[f]) filled++;
      var next = -1;
      if (filled < target) {
        for (var i = 0; i < slots.length; i++) {
          if (!slots[i]) {
            next = i;
            break;
          }
        }
      }
      if (next > -1) {
        window.setTimeout(function () {
          openPicker(next);
        }, 260);
      }
      return;
    }

    if (t.closest('[data-pick-back]')) {
      renderPickStyles();
      return;
    }

    if (t.closest('[data-pick-close]') || t.closest('.tlc-pick__veil')) {
      closePicker();
      return;
    }

    var tierBtn = t.closest('[data-tier]');
    if (tierBtn) {
      target = Number(tierBtn.getAttribute('data-tier')) || SLOTS;
      renderTiers();
      renderNudge();
      scrollToId('offer');
      var open1 = -1;
      for (var q = 0; q < slots.length; q++) {
        if (!slots[q]) {
          open1 = q;
          break;
        }
      }
      if (open1 > -1) {
        window.setTimeout(function () {
          openPicker(open1);
        }, reduceMotion ? 60 : 620);
      }
      return;
    }

    var heroSw = t.closest('[data-hero]');
    if (heroSw) {
      autoStop();
      setHero(Number(heroSw.getAttribute('data-hero')));
      return;
    }

    /* Gallery card → build the combo here instead of navigating away. Modifier
       and middle clicks are left alone so "open in new tab" still works, and the
       href stays intact for crawlers and for a JS-less visitor. */
    var galCard = t.closest('[data-gal]');
    if (galCard && !ev.metaKey && !ev.ctrlKey && !ev.shiftKey && !ev.altKey && ev.button === 0) {
      ev.preventDefault();
      var styleIdx = Number(galCard.getAttribute('data-gal'));

      /* Never open a picker with nothing pickable in it. Counts what the other
         slots have already reserved, so the last unit cannot be double-claimed. */
      var st0 = STYLES[styleIdx];
      var pickable = 0;
      if (st0) {
        for (var v0 = 0; v0 < st0.variants.length; v0++) {
          var vv0 = st0.variants[v0];
          if (vv0.ok && Math.max(0, vv0.qty - claimed(vv0.id, -1)) > 0) pickable++;
        }
      }
      if (!pickable) {
        toast(T('toast.soldout'));
        return;
      }

      var slot = -1;
      for (var g = 0; g < slots.length; g++) {
        if (!slots[g]) {
          slot = g;
          break;
        }
      }
      if (slot < 0) {
        /* Nothing silently replaced — tell them what to do instead. */
        toast(T('toast.full'));
        scrollToId('offer');
        return;
      }
      scrollToId('offer');
      window.setTimeout(function () {
        pickSlot = slot;
        el.pick.setAttribute('data-open', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        /* Straight to step 2 — they already chose the style by clicking it. */
        renderPickSizes(styleIdx);
      }, reduceMotion ? 60 : 520);
      return;
    }

    var langBtn = t.closest('[data-lang-btn]');
    if (langBtn) {
      setLang(langBtn.getAttribute('data-lang-btn'));
      return;
    }

    if (t.closest('[data-theme-toggle]')) {
      setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
      return;
    }

    if (t.closest('[data-cta]') || t.closest('[data-dock-cta]')) {
      checkout();
      return;
    }

    if (t.closest('[data-fcart]')) {
      var fp = priceState();
      if (fp.count === SLOTS) checkout();
      else scrollToId('offer');
      return;
    }

    var jump = t.closest('[data-jump]');
    if (jump) {
      ev.preventDefault();
      scrollToId(jump.getAttribute('data-jump'));
      return;
    }
  });

  root.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.name === 'tlc-area') {
      area = t.value === 'outside' ? 'outside' : 'inside';
      renderSummary();
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && el.pick && el.pick.getAttribute('data-open') === 'true') {
      closePicker();
      return;
    }
    /* Filled slots are divs with role=button, so Enter/Space need wiring. */
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    var focused = document.activeElement;
    if (!focused || !focused.getAttribute) return;
    if (focused.getAttribute('data-filled') === 'true') {
      ev.preventDefault();
      openPicker(Number(focused.getAttribute('data-slot')));
    }
  });

  /* ── Boot ──────────────────────────────────────────────────────────────── */
  readEnglish();
  for (var seedKey in EN_JS) {
    if (Object.prototype.hasOwnProperty.call(EN_JS, seedKey) && EN[seedKey] == null) {
      EN[seedKey] = EN_JS[seedKey];
    }
  }

  var savedLang;
  var savedTheme;
  try {
    savedLang = localStorage.getItem('tlc-lang');
    savedTheme = localStorage.getItem('tlc-theme');
  } catch (e) {}
  if (savedTheme === 'dark' || savedTheme === 'light') {
    document.documentElement.setAttribute('data-theme', savedTheme);
  }
  setLang(savedLang === 'bn' ? 'bn' : 'en');

  setupReveal();
  setupNav();
  setupAutoplay();
  readCart();
})();
